export default {
  button: {
    cancel: 'キャンセル',
    add: '追加',
    register: '登録',
    save: '保存',
    edit: '編集',
    login: 'ログイン',
    logout: 'ログアウト',
    setting_suru: '適用する',
    search: '検索',
    select: '選択',
    select_via_map: '地図合わせ',
    select_via_property_map: '選択する 地図経由',
    move_floor_here: 'フロアをここに移動',
    move_geofence_here: 'ここに移動',
    move_pin_here: 'ピンをここに移動',
    export_csv: 'CSVエクスポート',
    import_csv: 'CSVインポート',
    import: 'インポート',
    place_mode: '場所モード',
    user_mode: 'ユーザーモード',
    page_data: 'ページ',
    click_select: 'クリックして選択',
    open_video: '動画を開く',
    link: 'Link',
    unlink: 'Unlink',
  },
  breadcrumb: {
    user_info_manage: '利用者情報一覧',
    beacon_info_manage: 'ビーコン情報一覧',
    beacon_carried_info_manage: '移動ビーコン情報一覧',
    card_info_manage: 'カード情報一覧',
    category_info_manage: '分類情報一覧',
    floor_info_manage: 'フロア情報一覧',
    user_seach_dashboard: '利用者位置検索',
  },
  label: {
    mode: 'モード',
    category_name: '分類名',
    category_1: '大分類',
    category_2: '中分類',
    category_3: '小分類',
    search_placeholder: '検索...',
    search_by_placeholder: 'で検索',
    san_id: 'カードID',
    user_id: '利用者ID',
    user: '利用者',
    users: 'ユーザーズ',
    username: '氏名',
    category: '分類',
    category_id: '分類ID',
    beacon: 'ビーコン',
    beacon_animation: 'ビーコンアニメーション',
    card: 'カード',
    card_number: 'カード番号',
    current_floor: '所在地',
    current_battery: '電池',
    current_location: '現在地',
    floor_name: 'フロア名',
    floor_id: 'フロアID',
    building_name: '建物名',
    floor: 'フロア',
    floor_file: '図面ファイル',
    csv_file: 'CSVファイル',
    major: 'Major',
    minor: 'Minor',
    lon: '経度',
    lat: '緯度',
    camera: 'カメラ',
    camera_display: 'ビデオカメラ',
    camera_address: 'カメラアドレス',
    camera_show: 'カメラを表示',
    camera_tracking: 'ユーザーの追跡',
    beacon_uuid: 'ビーコンUUID',
    floor_sw_lat: '図面SW緯度',
    floor_sw_lon: '図面SW経度',
    floor_ne_lat: '図面NE緯度',
    floor_ne_lon: '図面NE経度',
    floor_angle: '図面角度',
    floor_map_zoom: '図面拡大',
    possition: '配置位置',
    num_beacon: 'ビーコン設置数',
    announce_heading: 'Social Area Networks からのお知らせ',
    faq_heading: 'よくあるご質問',
    map_adjust: '地図合わせ',
    map_adjust_parameters: '地図合わせパラメータ',
    search_card_info: 'カード情報検索',
    search_beacon_info: 'ビーコン情報検索',
    search_category_info: '分類情報検索',
    search_user_info: 'ユーザー情報検索',
    search_floor_info: 'フロア情報検索',
    search_sanid_info: 'Search San ID information',
    refresh_location_time: '画面自動更新頻度［sec］',
    card_off_after_minutes: 'カード非表示にする［minute］',
    minimum_number_locations: '場所の最小数 [number]',
    gps_error_acceptable_rank: 'GPS誤差許容範囲［m］',
    csv_columns_format: 'CSV列形式',
    floor_opacity: 'フロア透明度',
    last_updated: '最終更新',
    gps_mode: 'GPS',
    gps_ok: 'GPS OK',
    gps_ng: 'GPS NG',
    beacon_ng: 'ビーコンNG',
    status: 'ステータス',
    color: 'カラー',
    type: 'タイプ',
    people: 'ヒト',
    things: 'モノ',
    location: '場所',
    analysis_chart_title: '分析チャート',
    positioning: '測位中...',
    arrived_at: '到着時間',
    entered_at: 'に登場',
    leaveded_at: 'で出発',
    score: 'スコア',
    pan_id: 'Pan ID',
    jbox_type: 'JBox Type',
    date_slot: 'Slot',
    outside_title: '屋外',
    outside_floor: '屋外',
    mobile_username: 'モバイルユーザー名',
    password: 'Password',
    device: '機器',
    place: '場所',
    remaining_qty: '積算投与量',
    time: '積算時間',
    detail: '詳細',
    sensor: 'センサー',
    collapse_detail: '詳細を閉じる',
    dripnavi_normal: '流量範囲内',
    dripnavi_low: '流量低い',
    dripnavi_high: '流量高い',
    dripnavi_no: '滴下無し',
    jcard: 'JCard',
    smart_jcard: 'Smart JCard',
    press_to_add: 'クリックで選択するか入力します。',
    press_to_remove: 'クリックまたは入力して削除',
    press_to_selectAll: 'クリックするか入力してすべて選択',
    press_to_unselectAll: 'クリックまたは入力してすべて削除',
    placeholder_tag: '新しいタグとしてこれを追加',
    selected: '選択済み',
    select_users: 'ユーザーの選択',
    select_actions: '行動',
    select_bg_colors: '背景メッセージの色',
    select_range_date: '範囲を選択',
    from_yesterday: '範囲を選択',
    from_one_week: '一週間から',
    from_one_month: '一ヶ月から',
    geofence_name: 'ジオフェンス名',
    geofence: 'ジオフェンス',
    single: 'シングル',
    multiple: '複数',
    ok: 'OK',
    see_history_tracking: '{user} の履歴追跡を参照してください',
    history_tracking: '履歴追跡',
    selecte_user_tracking: 'ユーザー追跡を選択',
    read: '読む',
    unread: '未読',
    exit: '退場',
    enter: '入場',
    action: 'アクション',
    email: '電子メール',
    recipients: '受信者',
    in: 'IN',
    out: 'OUT',
    messages: 'メッセージ',
    target: '目標',
    patient: '患者',
    auto_exit_detect: '自動終了',
    feature: '特徴',
    width: '横幅',
    height: '高さ',
    order: 'ご注文',
    full: 'フル',
    user_type: 'ユーザータイプ',
    filter_text: 'フィルターテキスト',
    all: '全タイプ',
    name: '氏名',
    widget_setting: 'ホームウィジェット',
    internal_settings: '内部設定',
    personal_settings: '個人設定',
    link: 'Link',
    env_information: '環境情報',
    mitsuiwa_beacon: 'Mitsuiwaビーコン',
    optional_feature: 'オプション機能',
    drip_navi: 'ドリップナビ',
  },
  menu: {
    viewer: '閲覧機能',
    dashboard: 'ダッシュボード',
    user_search: 'ユーザ検索',
    link: 'Link',
    manage: '管理機能',
    system_menu: 'システムメニュー',
    indoor_map: '屋内マップ',
    outdoor_map: '屋外マップ',
    work_recorder: 'チャート',
    time_line: 'ワークレコーダー',
    stamp_rally: 'スタンプラリー',
    geofences: 'ジオフェンス',
    geofence_monitor: 'ジオフェンスモニター',
    notification: '通知',
    manage_category: '分類情報管理',
    manage_carried_device: '位置デバイス',
    manage_fixed_device: '固定デバイス',
    manage_card: 'カード管理',
    manage_card_gateway: 'ビーコンスキャナ管理',
    manage_beacon: 'ビーコン管理',
    manage_floor: 'フロア管理',
    manage_user: '利用者管理',
    system_setting: 'システム設定',
    notification_setting: '通知設定',
  },
  messages: {
    data_not_found: 'データが見つかりませんでした。',
    user_not_found: 'ユーザーが見つかりませんでした。',
    unit_required: 'ユニットを入力してください。',
    username_required: 'ユーザー名を入力してください。',
    password_required: 'パスワードを入力してください。',
    drop_file_here_or_select_a_file: 'ここにファイルをドロップまたはファイルを選択して下さい。',
    are_you_sure_want_to_delete: '削除した情報は復元できませんが、よろしいですか？',
    has_refs_data_are_you_sure_want_to_delete: '関連する情報がありますが、削除しますか？',
    save_success: '保存は正常に完了されました。',
    update_success: '更新は正常に完了されました。',
    delete_success: '削除は正常に完了されました。',
    field_is_required: '入力してください。',
    major_minor_is_required_and_unique: 'Major/Minorは必須かつシステム内で同じ組み合わせを登録できません。',
    location_not_found: '場所が見つかりませんでした。',
    floor_not_found: 'フロアが見つかりませんでした。',
    user_just_go_out: '{username}は外室に出ました。',
    user_just_goto_floor_x: '{username}は「{location}」に移動しました。',
    card_off_after_minutes_desc: 'データが送信されない場合、カードは「{minutes}」分「{seconds}」秒後に自動的に隠されます。',
    minimum_number_locations_desc:
      'アクションの場所にあるレコードの数（メールの送信は現在ジオフェンスで利用可能です）。',
    download_prepare: 'ダウンロードの準備中です。お待ちください。',
    download_ready: 'データが準備されました。ファイル圧縮中です。',
    download_success: 'ダウンロードに成功しました。',
    download_error: '問題が発生しました。空白を変換することはできません。',
    device_ip_invalid: 'このIPアドレスは無効です！',
    san_ids_warning: '*{deviceId}がJBOXサーバーに存在しない場合、追加されません。',
    san_ids_error: 'これらの{deviceId}はJBOXに存在しません。 確認して再度インポートしてください。',
    unit_deactivate: 'このユニットは非アクティブ化されており、古いデータのみを表示できます。',
    go_inside_floor: 'ユーザーはフロアの別の部屋に行きます',
    go_outside_floor: 'ユーザーが床から出ます',
    user_appeared_once: 'このユーザーが現れ、すぐに去ります！',
    beacon_off: 'ビーコン外れ',
    beacon_recovery: 'ビーコン復旧',
    beacon_failure_position: 'ビーコン測位失敗',
    beacon_recovery_position: 'ビーコン測位復旧',
    location_failure_gps: 'GPS 測位失敗',
    location_position_gps: 'GPS 測位復旧',
    invalid_email: '無効なメールアドレスのフォーマットです。',
    field_is_greater_than: 'このフィールドは {number} より大きくなければなりません。'
  },
  pagination: {
    per_page: '件表示',
    of_pages: 'ページ目',
  },
  type: {
    day: '日',
    range: '範囲',
  },
  placeholder: {
    ip_address: 'http://192.168.0.1:8080/path?param=value',
    input_filter: 'フィルタリングするテキストを入力します。',
    input_order: '序数を入力する',
  },
  widget_setting: {
    user_search: 'ユーザ検索',
    indoor: '屋内マップ',
    outdoor: '屋外マップ',
  },
  all: '全て',
  delete: '削除',
  UUID: 'UUID',
  total_score: '合計スコア',
}
